<template>
  <div>
    <custom-actions show-back :title="title + '审批'">
      <el-form class="form" :model="formData" :rules="rules" ref="form2" label-width="130px">
        <!-- 充值流程 -->
        <template v-if="depositType === '1'">
          <!-- 业务员 -->
          <el-row v-if="formData.approvalStatus === '1'">
            <el-col :span="24">
              <el-form-item prop="depositChange" :label="depositTypeMap.get(formData.depositType) + '金额'">
                {{ formData.depositChange || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件">
                <file-upload readonly v-model="formData.fileList"></file-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 财务 -->
          <el-row v-if="formData.approvalStatus === '2'">
            <el-col :span="24">
              <el-form-item label="流水凭证单号">
                {{ formData.depositNumber || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="付款银行" prop="fkBank">
                {{ formData.fkBank || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="收款银行">
                {{ formData.receivingBank || '' }}
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- 退还流程 -->
        <template v-if="depositType === '2'">
          <el-form-item label="退还金额" prop="depositChange">
            {{ formData.depositChange || '' }}
          </el-form-item>
          <el-form-item label="收款银行" prop="receivingBank">
            {{ formData.receivingBank || '' }}
          </el-form-item>
          <el-form-item label="收款账号" prop="receivingAccount">
            {{ formData.receivingAccount || '' }}
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <span style="white-space: pre-wrap; overflow-wrap: anywhere;">{{ formData.remark || '' }}</span>
          </el-form-item>
          <el-form-item label="附件">
            <file-upload readonly v-model="formData.fileList"></file-upload>
          </el-form-item>
        </template>

        <!-- 转换流程 -->
        <template v-if="depositType === '3'">
          <el-form-item label="转换金额" prop="depositChange">
            {{ formData.depositChange || '' }}
          </el-form-item>
          <el-form-item label="附件">
            <file-upload readonly v-model="formData.fileList"></file-upload>
          </el-form-item>
        </template>

        <el-form-item v-if="['3'].includes(depositType)" label="流程PDF">
          <el-button type="primary" @click="onDownPDF">下载</el-button>
        </el-form-item>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.submitTime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24">
                        审批状态：
                        <el-tag v-if="item.approvalStatus == '1'">待审批</el-tag>
                        <el-tag type="success" v-if="item.approvalStatus == '2'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.approvalStatus == '3'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批名称：{{ item.approvalName || '--' }} </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        审批意见：{{ item.approvalComments || '--' }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">审批人：{{ item.approver || '--' }}</el-col>
                      <el-col :span="12">审批时间：{{ item.submitTime || '--' }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">提交人：{{ item.submitter || '--' }}</el-col>
                      <el-col :span="12">提交时间：{{ item.submitTime || '--' }}</el-col>
                    </el-row>
                    <el-row v-if="item.fileList && item.fileList.length > 0">
                      <el-col :span="24">
                        附件：
                        <file-upload readonly v-model="item.fileList"></file-upload>
                      </el-col>
                    </el-row>
                  </el-card>

                </el-timeline-item>
              </el-timeline>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" v-if="['1', '2', '3'].includes(formData.approvalStatus)"
                @click="showDialog">审批</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </custom-actions>

    <FundApprovalDialog :depositType="depositType" :approvalStatus="formData.approvalStatus" :relatedId="depositId"
      :visible.sync="dialogVisible" @success="$router.back()"></FundApprovalDialog>
  </div>
</template>
<script>
import { depositType, transactionType } from '@/utils/dict'
import FundApprovalDialog from './FundApprovalDialog.vue'

export default {
  name: 'FundApproval',
  components: {
    FundApprovalDialog
  },
  data() {
    return {
      dialogVisible: false,
      depositTypeMap: depositType,
      formData: {
        depositNumber: '', // 订单编号
        isJr: '', // 是否收益金
        fkBank: '', // 付款银行
        userId: '', // 关联客户ID，关联客户表
        depositStatus: '', // 工单状态，1审批中2审批通过3作废
        approvalStatus: '', // 审批状态，1待审批，2审批通过，3审批驳回
        depositType: '', // 类型1充值2退还3保证金转货款
        depositChange: '', // 充值/退还金额
        transactionType: '', // 金额类型 1 保证金 2 货款
        transferDate: '', // 转账日期
        receivingBank: '', // 收款银行
        receivingAccount: '', // 收款账号
        remark: '', // 退款备注
        fileList: [] // 附件列表
      },
      rules: {
        approvalStatus: [
          {
            required: true,
            message: '请选择审批状态',
            trigger: ['blur', 'change']
          }
        ],
        approvalComments: [
          {
            required: true,
            message: '请输入审批意见',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  computed: {
    depositId() {
      return this.$route.query.depositId
    },
    depositType() {
      return this.$route.query.depositType
    },
    transactionType() {
      return this.$route.query.transactionType
    },
    title() {
      let name = transactionType.get(this.transactionType) || ''
      if (this.transactionType === '2') {
        name = '货款'
      }
      const type = depositType.get(this.depositType) || ''
      return name + type
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    onDownPDF() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.bondRecord.txUserDepositNewToPdf, {
        depositId: this.depositId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']

          let fileName = '审批单.pdf'

          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      console.log('decodeURIComponent(fileName)', decodeURIComponent(fileName))
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    showDialog() {
      this.dialogVisible = true
    },
    loadDetails() {
      this.$axios.get(this.$apis.bondRecord.selectYxUserDepositNewByDepositId, {
        depositId: this.depositId
      }).then(res => {
        this.formData = res || {}
      })
    },
    handleClose() {
      this.$emit('closeDlg')
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true
        this.formData.relatedId = this.relatedId

        let params = {}
        if (this.urlType === '5') {
          delete this.formData.fileList
          params = {
            recordId: this.relatedId,
            approveResult: this.formData.approvalStatus,
            approveComment: this.formData.approvalComments
          }
        } else {
          params = this.formData
        }
        console.log('params: ', params)

        const obj = {
          1: this.$apis.bondRecord.approvaYxUserDepositRecord, // 保证金充值退还审核
          2: this.$apis.orderManage.approvalYxPriceOrder, // 锁价订单审核
          3: this.$apis.deliveryOrder.approvalYxPickupOrder, // 提货订单
          4: this.$apis.bondRecord.approvaYxUserGoodsRecord, // 发货订单
          5: this.$apis.vehicleAccess.updatePaVehicleOut, // 车辆出入厂
          6: this.$apis.orderManage.approvalYxPriceOrderRes // 车辆出入厂
        }
        this.$axios.post(obj[this.urlType], params).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
